<template>
  <van-popup class="c-appshare" :class="themeClass" v-model="show" position="bottom">
    <div class="section-share-containner">
      <div class="section-share-header">
        <span class="title">分享至</span>
        <em class="btn-cancel" @click="handleCancel">
          <svg-icon icon-class="close"></svg-icon>
        </em>
      </div>
      <div class="section-share-list">
        <div class="section-share-item" :class="item.name === 'CopyUrl' ? 'btn-copy-link' : ''" v-for="item in apiList" :key="item.id" @click="openAppShare(item)">
          <img class="section-share-item-icon" :src="item.icon" />
          <div class="section-share-item-label">{{ item.label }}</div>
        </div>
      </div>
    </div>
    <div class="section-share-footer">
      <button type="button" class="btn-cancel" @click="handleCancel">取消</button>
    </div>
  </van-popup>
</template>
<script>
import { Popup as VanPopup } from 'vant';
import Clipboard from 'clipboard';
import iconWechat from '@/assets/images/components/icon-wechat@2x.png';
import iconWechatMoments from '@/assets/images/components/icon-wechatMoments@2x.png';
import iconWeibo from '@/assets/images/components/icon-weibo@2x.png';
import iconQQ from '@/assets/images/components/icon-qq@2x.png';
import iconDingtalk from '@/assets/images/components/icon-dingtalk@2x.png';
import iconLink from '@/assets/images/components/icon_link@2x.png';
export default {
  props: {
    theme: {
      type: String,
      default: 'default',
    },
  },
  components: { VanPopup },
  data() {
    return {
      show: false,
      innerShareOptions: {
        // apiList: ['Wechat', 'WechatMoments', 'Zeeho', 'ZeehoMoments', 'SinaWeibo', 'QQ', 'DingTalk', 'CopyUrl'],
        apiList: ['Wechat', 'WechatMoments', 'SinaWeibo', 'CopyUrl'],
        title: '',
        titleUrl: '',
        text: '',
        url: '',
        shareType: '',
        success: () => {},
        fail: () => {},
        complete: () => {},
      },
    };
  },
  computed: {
    themeClass() {
      return this.theme;
    },
    apiDatas() {
      return {
        Wechat: { icon: iconWechat, label: ' 微信 ' },
        WechatMoments: { icon: iconWechatMoments, label: ' 朋友圈 ' },
        SinaWeibo: { icon: iconWeibo, label: ' 新浪 ' },
        QQ: { icon: iconQQ, label: ' QQ ' },
        DingTalk: { icon: iconDingtalk, label: ' 钉钉 ' },
        Zeeho: { icon: '', label: ' 好友 ' },
        ZeehoMoments: { icon: '', label: '极客' },
        Letter: { icon: '', label: ' 私信和群 ' },
        CopyUrl: { icon: iconLink, label: ' 链接 ' },
      };
    },
    apiList() {
      console.log(this.innerShareOptions.apiList);
      return this.innerShareOptions.apiList.map((name) => ({ name, label: this.apiDatas[name].label, icon: this.apiDatas[name].icon, id: Math.random() }));
    },
  },
  methods: {
    setOptions(options = {}) {
      const apiList = this.innerShareOptions.apiList;
      this.innerShareOptions = { ...this.innerShareOptions, ...JSON.parse(JSON.stringify(options)), success: options.success || this.success, fail: options.fail || this.fail };
      this.innerShareOptions.apiList = this.innerShareOptions.apiList.length ? this.innerShareOptions.apiList : apiList;
    },
    open(options = {}) {
      this.setOptions(options);
      this.show = true;
      this.copyUrl();
    },
    hide() {
      this.show = false;
    },
    handleCancel() {
      this.show = false;
    },
    copyUrl() {
      const titleUrl = this.innerShareOptions.titleUrl;
      this.$nextTick(() => {
        const clipboard = new Clipboard('.btn-copy-link', {
          // 绑定需要的触发的dom
          text() {
            return titleUrl;
          },
        });

        clipboard.on('success', (e) => {
          this.innerShareOptions.complete && this.innerShareOptions.complete(e);
          this.innerShareOptions.success && this.innerShareOptions.success(e);
          this.show = false;
          this.$toast('已复制');
        });
        clipboard.on('error', (e) => {
          this.innerShareOptions.complete && this.innerShareOptions.complete(e);
          this.innerShareOptions.error && this.innerShareOptions.error(e);
        });
      });
    },
    openAppShare(item, index) {
      console.log('我点击了' + item.name);
      console.log(window.android);
      const { success } = this.innerShareOptions;
      // if (item.name === 'CopyUrl') {
      //   return;
      // }
      if (success) {
        success({ ...item, index });
      }
    },
  },
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {},
};
</script>
<style lang="scss" scoped>
.c-appshare {
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  border-radius: 8px;
  --van-popup-round-border-radius: 0;
  --van-action-sheet-header-height: 54px;
  background: none;
  line-height: 1;
  .section-share-containner {
    width: 375px;
    min-height: 167px;
    background: rgba(255, 255, 255, 1);
    border-radius: 18px 18px 0px 0px;
  }

  .section-share-header {
    position: relative;
    width: 100%;
    justify-content: flex-start;
    padding: 14px 0 0;
    line-height: 1.5;
    .title {
      margin-left: 24px;
      font-weight: 600;
      font-size: 14px;
      color: #000000;
    }
    .btn-cancel {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 14px;
      right: 24px;
      width: 30px;
      height: 30px;
      font-size: 15px;
      color: #000000;
    }
  }
  .section-share-footer {
    width: 345px;
    margin: 9px auto 15px;
    display: flex;
    flex-direction: row;
    display: none;
    .btn-cancel {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      flex: 1;
      border: none;
      position: absolute;
      top: 0;
      padding: 0;
      height: 48px;
      background: #ffffff;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
      border-radius: 8px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      &:active {
        color: #555555;
      }
    }
  }
  .section-share-list {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
    box-sizing: border-box;
    // padding: 0 15px;
    padding: 18px 45px;
  }
  .section-share-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 28px 18px 0;
    &:nth-of-type(4n) {
      margin-right: 0;
    }
  }
  .section-share-item-icon {
    width: 50px;
    height: 50px;
  }
  .section-share-item-label {
    margin: 10px 0 0;
    font-size: 12px;
    font-weight: 400;
    color: #000000;
  }
}
.c-appshare.opacity {
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  border-radius: 8px;
  --van-popup-round-border-radius: 0;
  --van-action-sheet-header-height: 54px;
  background: none;
  line-height: 1;
  .section-share-containner {
    width: 375px;
    height: 247px;
    background: rgba(255, 255, 255, 0.27);
    border-radius: 18px 18px 0px 0px;
  }
  .section-share-header {
    position: relative;
    width: 100%;
    justify-content: flex-start;
    padding: 14px 0;
    line-height: 1.5;
    .title {
      margin-left: 24px;
      font-weight: 600;
      font-size: 14px;
      color: #ffffff;
    }
    .btn-cancel {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      position: absolute;
      // top: 20px;
      right: 15px;
      width: 30px;
      height: 30px;
      font-size: 12px;
      color: #ffffff;
    }
  }
  .section-share-footer {
    display: none;
  }
  .section-share-list {
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    padding: 0 45px;
    .section-share-item {
      display: flex;
      flex-direction: column;
      position: relative;
      width: 50px;

      &-icon {
        width: 50px;
        height: 50px;
        border-radius: 50%;
      }
      &-label {
        margin-top: 4px;
        line-height: 1.5;
        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
      }
    }
  }
}
</style>
